import type { ReactNode } from "react";
import Alert from "@mui/material/Alert";
import type { AlertColor } from "@mui/material/Alert";
import type { SxProps, Theme } from "@mui/material/styles";

interface NoteAlertProps {
  severity: AlertColor;
  children: ReactNode;
  onClose?: () => void;
  sx?: SxProps<Theme>;
}

/** A short note in a section as an MUI Alert in its severity's colour; dismissible when `onClose` is given. */
export const NoteAlert = (props: NoteAlertProps) => {
  const { severity, children, onClose, sx } = props;

  return (
    <Alert
      onClose={onClose}
      severity={severity}
      sx={sx}
    >
      {children}
    </Alert>
  );
};
